<template>
  <!-- Centered logo -->
  <div class="text-center">
    <b-img
      :src="appLogoImage"
      alt="logo"
      width="50"
    />
    <h2 class="brand-text text-primary ml-1 mt-1">
      {{ appName }}
    </h2>
    <b-spinner
      class="text-primary"
      label="Cargando..."
      style="width: 3rem; height: 3rem;"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BImg, BSpinner } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BImg,
    BSpinner,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
